// extracted by css-extract-rspack-plugin
export default {"sales-description-container":"x2BG44R8MIv9zHWA_nVwP"};